import { defaultDetail } from './VenueDetail';

const VenueDefaultRenderer = () => {
  return defaultDetail;
};

export default VenueDefaultRenderer;
